module.exports = __webpack_public_path__ + "static/media/dates-demo.6ad5becd.png";